import styles from './../item.module.scss'

import { Helmet } from 'react-helmet';

import { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { UserContext } from '@/context/user';

import { Button, Card, Modal } from 'antd';
import { ShareAltOutlined } from '@ant-design/icons';

import { ButtonQuestion } from '@/components/button/question';

import { sendEvent } from '@/utils/ga';
import { getNavUrl } from '@/utils/navigation';

export const PageStrawberry = () => {
  const history = useHistory()

  const {
    ready,
    debugMode,
    ga4Attr,
    uaAttr,
    tagManagerAttr,
    optimizeAttr,
    userId,
    resetUserContext,
  } = useContext(UserContext)

  const onCartClick = (e: React.MouseEvent) => {
    Modal.confirm({
      title: '장바구니 담기 완료',
      content: '장바구니 페이지로 이동하시겠습니까?',
      okText: '네',
      okType: 'primary',
      onOk: () => {
        history.push(getNavUrl('/cart?item=strawberry'))
      },
      cancelText: '아니오',
      onCancel: () => { }
    });
    sendEvent('add_to_cart', {
      currency: 'KRW',
      value: 6590,
      items: [
        {
          item_id: "ITEM_2",
          item_name: "맛있는 딸기입니다!",
          item_category: "과일",
          price: 6590,
          quantity: 1
        }
      ]
    })
  }

  const onPurchaseClick = (e: React.MouseEvent) => {
    sendEvent('purchase', {
      currency: 'KRW',
      transaction_id: `T-${Date.now()}`,
      value: 6590,
      items: [
        {
          item_id: "ITEM_2",
          item_name: "맛있는 딸기입니다!",
          item_category: "과일",
          price: 6590,
          quantity: 1
        }
      ]
    })

    alert('딸기를 구매했습니다.')

    const hasTempGaId = window.location.href.includes('tempGaId=')

    if (!hasTempGaId) {
      history.push(getNavUrl('/purchase'))
      return
    }

    if (hasTempGaId) {
      Modal.info({
        title: '구글 애널리틱스 4를 공부하는 중이에요! 고마워요!',
        content: (
          <div>
            <p>구글 애널리틱스 4를 공부하는 중이에요! 고마워요!</p>
          </div>
        ),
        onOk() {},
      });
    }
  }

  const onShareClick = () => {
    if (ga4Attr?.id) {
      const gaId = ga4Attr.id
      const message = `https://www.turtlebooks.co.kr/ga4/item/strawberry?utm_campaign=winter_sale&utm_source=facebook&utm_medium=cpc&tempGaId=${gaId}`
      Modal.info({
        title: '아래 공유 링크를 복사해서 사용하세요',
        content: (
          <div>
            <p>{message}</p>
          </div>
        ),
        onOk() {},
      });
    }
  }

  return (
    <>
      <Helmet>
        <title>상품: 맛있는 딸기</title>
      </Helmet>
      <div className={styles.body}>
        <Card title="오늘은 맛있는 딸기를 드셔보세요" headStyle={{textAlign: 'left'}}>
          <div className={styles.content}>
            <div className={styles.colLeft}>
              <img className={styles.thumbnail} src="/ga4/strawberry.jpg"/>
              <p className={styles.author}>Photo by <a target="_blank" rel="noopener noreferrer" href="https://unsplash.com/@allecgomes?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Allec Gomes</a> on <a target="_blank" rel="noopener noreferrer" href="https://unsplash.com/s/photos/strawberry?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Unsplash</a></p>
            </div>
            <div className={styles.colRight}>
              <div className={styles.rowDescription}>
                <p className={styles.category}>과일</p>
                <p className={styles.title}>맛있는 딸기입니다!</p>
                <p className={styles.buy}><span className={styles.unit}>284</span>명의 사용자가 구매했습니다.</p>
                <hr className={styles.divider}/>
                <p className={styles.price}>6,590원<span className={styles.unit}>(100g당 659원)</span></p>
                {
                  ga4Attr?.id && (
                    <ShareAltOutlined className={styles.share} style={{ fontSize: '30px', color: '#1890ff' }}onClick={() => onShareClick()}/>
                  )
                }
              </div>
              <div className={styles.rowAction}>
                <div className="colCart">
                  <Button onClick={(e) => onCartClick(e) } className={styles.btnCart}>장바구니 담기</Button>
                  <ButtonQuestion
                    sizePercentage="120%"
                    content={() => {
                      return (
`
gtag('event', 'add_to_cart', {
  currency: 'KRW',
  value: 6590,
  items: [
    {
      item_id: "ITEM_2",
      item_name: "맛있는 딸기입니다!",
      item_category: "과일",
      price: 6590,
      quantity: 1
    }
  ]
})
`
                      )
                    }}
                  />
                </div>
                <div className="colPurchase" style={{marginTop: '14px'}}>
                  <Button onClick={(e) => onPurchaseClick(e) } type="primary" className={styles.btnCart}>구매하기</Button>
                  <ButtonQuestion
                    sizePercentage="120%"
                    content={() => {
                      return (
`
gtag('event', 'purchase', {
  currency: 'KRW',
  transaction_id: 'T-${Date.now()}',
  value: 6590,
  items: [
    {
      item_id: "ITEM_2",
      item_name: "맛있는 딸기입니다!",
      item_category: "과일",
      price: 6590,
      quantity: 1
    }
  ]
})
`
                      )
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </>
  )
}